<template>
  <div class="modal-wrap" :class="{ mobile: isMobile, 'no-border-radius': noBorderRad }" ref="parent">
    <div class="header" v-if="handleProps && handleProps.title">
      <div class="title">{{ handleProps.title }}</div>
      <div class="close" v-if="!handleProps.required" @click="closePoll">
        <span class="material-icons">close</span>
      </div>
    </div>
    <div class="logo-wrap" v-if="logo">
      <img src="/api/logo" alt="logo" />
    </div>
    <transition
      appear
      :name="transitionName"
      mode="out-in"
      @after-enter="handleAnimation"
    >
      <component
        :is="dynComp"
        v-bind="dynProps"
        v-on="dynEvents"
        ref="element"
      />
    </transition>
    <div class="w-100" v-if="hasSSO && routePath !== '/validate' && !removesso">
      <transition
        appear
        :name="transitionName"
        mode="out-in"
        @after-enter="handleAnimation"
      >
        <sso-wrapper />
      </transition>
    </div>
  </div>
</template>

<script>
import isMobileMixin from "../../mixins/isMobileMixin";
import SsoWrapper from "../auth/sso/SsoWrapper";
import { mapState } from "vuex";
export default {
  components: {
    SsoWrapper,
  },
  props: {
    noBorderRad: {
      type: Boolean,
      default: false
    },
    comp: Object,
    removesso: {
      type: Boolean,
      default: false,
    },
    logo: {
      type: Boolean,
      default: true,
    },
    handleProps: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    handleEvents: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
    transitionName: {
      type: String,
      required: false,
      default: () => "",
    },
  },
  mixins: [isMobileMixin],
  computed: {
    ...mapState(['fairConfig']),
    routePath() {
      return this.$route.path;
    },
    routeParam() {
      return this.$route.params.action;
    },
    dynComp() {
      return this.comp;
    },
    dynEvents() {
      return this.handleEvents;
    },
    dynProps() {
      return this.handleProps;
    },
    hasSSO () {
      return !!Number(this.fairConfig.FC_SSO);
    },
  },
  watch: {
    dynProps: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
  },
  mounted(){
    console.log(this.handleProps,'props');
  },
  methods: {
    closePoll() {
      this.$emit('close')
    },
    gotoSSO() {
      this.$router.push("/sso");
    },
    toBackToLogin() {
      this.$router.push("/login");
    },
    handleAnimation() {
      const el = this.$refs.parent;
      if (el) {
        el.classList.remove("hidden");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.modal-wrap {
  position: relative;
  max-width: 80%;
  z-index: 1;
  padding: 50px;
  background: var(--main-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 60px;
  // overflow: hidden;
  box-sizing: border-box;
  &.no-border-radius {
    border-radius: 0 !important;
  }
  &.mobile {
    padding: 8vw;
    min-height: calc(100vh - var(--nav-height));
    width: 100%;
    border-radius: 0;
  }
  &.hidden {
    overflow: hidden;
  }
}
.logo-wrap {
  display: flex;
  justify-content: center;
  margin: 20px 0 30px;
  max-width: 400px;
}
.sso {
  margin: 20px 0 0 auto;
  padding: 5px 10px;
  width: unset;
  background: var(--button-color-yellow);
  text-align: center;
}
.w-100 {
  width: 100%;
}
.header {
  z-index: 2;
  padding: 0 20px;
  top: -1px;
  left: 0;
  height: 50px;
  width: 100%;
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-top-left-radius: 60px;
  border-top-right-radius: 60px;
  .close {
    cursor: pointer;
    margin-right: 20px;
    height: 24px;
    width: 24px;
  }
  .title {
    line-height: 50px;
    height: 50px;
    font-weight: 500;
    font-size: 18px;
    margin-left: 30px;
  }
}
</style>